import { render } from "./Contact-L.vue?vue&type=template&id=e4474526&scoped=true"
const script = {}

import "./Contact-L.vue?vue&type=style&index=0&id=e4474526&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4474526"]])

export default __exports__